<template>
  <div class="w-full p-2 bg-white">
    <div class="w-full py-1 flex space-x-2">
      <template v-if="!editable">
        <vs-button @click="editAnnouncement" icon-pack="feather" icon="icon-edit">
          {{ $t('buttons.edit') }}
        </vs-button>
      </template>

      <div class="w-2/3 flex flex-row pr-1">
        <i class="mr-2 flag-icon" :class="announcementName"/>
        <vs-input class="w-2/3" v-model="announce.title" :disabled="!editable"/>
      </div>

      <div class="w-1/3">
        <vs-switch v-model="announce.active" :disabled="!editable"/>
      </div>
    </div>

    <template v-if="editable">
      <div class="w-full">
        <vs-textarea v-model="announce.body" height="180px" rows="8" cols="10" class="w-full"/>
      </div>
      <div class="w-full flex justify-end space-x-2">
        <vs-button type="border" color="warning" @click="preview">
          {{ $t('buttons.preview') }}
        </vs-button>

        <vs-button type="border" color="red" @click="reset">
          {{ $t('buttons.cancel') }}
        </vs-button>

        <vs-button type="border" color="primary" @click="save">
          {{ $t('buttons.save') }}
        </vs-button>
      </div>
    </template>
  </div>
</template>

<script>
import {getLangByValue} from "@/helpers/lists";

export default {
  name: "AnnouncementItem",
  props: {
    value: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      announce: {},
      editable: false,
      loaded: false,
    }
  },
  watch: {
    value() {
      this.copyValue();
      this.loaded = true;
    }
  },
  computed: {
    announcementName() {
      if (this.announce.name) {
        let lang = this.announce.name.split('.')[1];
        return getLangByValue(lang).icon
      }
      return '';
    }
  },
  methods: {
    copyValue() {
      this.announce = Object.assign({}, this.value);
      this.editAnnouncement(false);
    },
    isValid() {
      return this.announce.title && this.announce.body;
    },
    editAnnouncement(val = true) {
      this.$nextTick(() => {
        this.editable = val;
      });
    },
    reset() {
      this.editAnnouncement(false);
      this.copyValue();
    },
    save() {
      this.$emit('input', this.announce);
      if (this.isValid()) {
        this.$emit('change', this.announce);
      }
    },
    preview() {
      this.$alma.dialogHtml({
        title: this.announce.title,
        html: this.announce.body
      });
    },
  },
  mounted: function() {
    this.copyValue();
  }
}
</script>

<style lang="scss">
  .vs-switch {
    &.vs-switch-active {
      span.vs-circle-switch.vs-switch--circle {
        background: $grey-light !important;
        border-width: 1px !important;
        border-color: rgba(113, 128, 150, var(--border-opacity)) !important;
      }
    }

    &:not(.vs-switch-active) {
      background: $grey-light !important;
      span.vs-circle-switch.vs-switch--circle {
        background: $primary !important;
        border-width: 1px !important;
        border-color: rgba(113, 128, 150, var(--border-opacity)) !important;
      }
    }
  }
</style>
